const rateAndShareModule = {
    initEvents() {
        $('[data-rate-input]').change(function (e) {
            e.preventDefault();
            const postId = e.target.closest('.block-rate-share').dataset.postId;

            const data = {
                action: 'markWidget',
                value: e.target.value,
                postId: postId,
            };

            let alreadyVoted = localStorage.getItem('alreadyVoted');

            if (!alreadyVoted) {
                alreadyVoted = {};
            } else {
                alreadyVoted = JSON.parse(alreadyVoted);
            }
            if (!alreadyVoted[data.postId]) {
                alreadyVoted[data.postId] = data.value;
            } else {
                return false;

            }

            $.post(ajaxurl, data, function (response) {
                response = JSON.parse(response);

                $('[data-avg-mark]').text(Number.parseFloat(response.avgMark).toFixed(1))
                $('[data-count-mark]').text(response.count)
                $('[data-count-text]').text(response.text)


                localStorage.setItem('alreadyVoted', JSON.stringify(alreadyVoted));
                rateAndShareModule.setVote();
            });
        });
    },

    setVote() {
        let alreadyVoted = localStorage.getItem('alreadyVoted');
        const postId = $('[name="post-id"]').attr('content');

        if (alreadyVoted) {
            alreadyVoted = JSON.parse(alreadyVoted);

            if (alreadyVoted[postId]) {
                $('[data-rate-input][value="' + alreadyVoted[postId] + '"]').prop('checked', true);
                $('.full-stars').addClass('full-stars-voted')
                $('[data-rate-input]').prop('disabled', true)
            }
        }

        $('.full-stars').show();
    },

    init() {
        this.initEvents();
        this.setVote();
    }
}

export default rateAndShareModule;
